import React, { Component, CSSProperties, ReactNode } from 'react';
import './Avatar.scss';
import { SingleUser } from '../../api/types';
import { Api } from '../../api';
import { store } from '../../app/store';
import { connect } from 'react-redux';
import avatarsActions from '../../app/avatars/actions';

interface AvatarProps {
  user?: SingleUser;
  url?: string;
  className?: string;
  style?: CSSProperties;
  storeAvatarInCache: (userId: number, url: string) => void;
}

interface AvatarState {
  avatarUrl: string;
  loading?: boolean;
}

class AvatarComponent extends Component<AvatarProps, AvatarState> {
  state: AvatarState = {
    avatarUrl: '/assets/avatar_placeholder.png',
  };

  componentDidMount(): void {
    this.loadAvatarUrl()
      .catch(() => undefined);
  }

  private async loadAvatarUrl(): Promise<void> {
    const { user, url, storeAvatarInCache } = this.props;
    if (url) {
      this.setState({ avatarUrl: url });
    } else if (user) {
      const urlFromCache = this.getAvatarFromStore(user.id);
      if (urlFromCache) {
        this.setState({ avatarUrl: urlFromCache });
      } else {
        this.setState({ loading: true });
        const blob = await Api.getAvatar(user.id)
          .catch(err => {
            this.setState({ loading: false });
            throw err;
          });
        const objectUrl = await this.createObjectURL(blob);
        this.setState({ avatarUrl: objectUrl, loading: false });
        storeAvatarInCache(user.id, objectUrl);
      }
    }
  }

  private createObjectURL(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (reader.result) {
          resolve(reader.result as string);
        } else {
          reject();
        }
      };
      reader.readAsDataURL(blob);
    });
  }

  private getAvatarFromStore(userId: number): string|undefined {
    return store.getState().avatars.cache[userId];
  }

  render(): ReactNode {
    const { user, className, style } = this.props;
    const { avatarUrl } = this.state;
    return (
      <div
        className={`avatar ${className || ''}`}
        style={{ ...style, backgroundImage: `url('${avatarUrl}')` }}
        title={`Avatar van ${user?.name || '[onbekend]'}`}
      />
    );
  }
}

export const Avatar = connect(
  null,
  dispatch => ({
    storeAvatarInCache: (userId: number, url: string) => dispatch(avatarsActions.set({ userId, url }))
  })
)(AvatarComponent);
